import React, { useState, useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { API_URL } from "..";

const EditAssetLayer = ({ assetData }) => {

    const locationId =  localStorage.getItem('locationID')
  const [formValues, setFormValues] = useState({
    title: "",
    costPrice: 0,
    quantity: 0,
    description: "",
    addedOn:'',
    locationId:locationId,
  });

  const [message, setMessage] = useState({
    status: false,
    reason: "",
    desc: "",
  });

  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  // Load initial data
  useEffect(() => {
    if (assetData) {
      setFormValues({
        title: assetData.title,
        costPrice: assetData.costPrice,
        quantity: assetData.quantity,
        description: assetData.description,
        addedOn: assetData.addedOn,
        locationId:locationId
      });
    }
  }, [assetData]);

  // Init Quill
  useEffect(() => {
    if (quillRef.current && !quillInstance.current) {
      quillInstance.current = new Quill(quillRef.current, {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: "" }, { align: "center" }, { align: "right" }],
          ],
        },
      });

      quillInstance.current.on("text-change", () => {
        const content = quillInstance.current.root.innerHTML;
        setFormValues((prev) => ({ ...prev, description: content }));
      });
    }

    return () => {
      if (quillInstance.current) {
        quillInstance.current.off("text-change");
        quillInstance.current = null;
      }
    };
  }, []);

  // Load description into Quill editor
  useEffect(() => {
    if (quillInstance.current && formValues.description) {
      quillInstance.current.root.innerHTML = formValues.description;
    }
  }, [formValues.description]);

  // Submit update
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formValues.title)
      return setMessage({ status: true, reason: "error", desc: "Title is required" });

    if (!formValues.costPrice || formValues.costPrice <= 0)
      return setMessage({
        status: true,
        reason: "error",
        desc: "Cost Price must be greater than 0",
      });

    if (!formValues.quantity || formValues.quantity <= 0)
      return setMessage({
        status: true,
        reason: "error",
        desc: "Quantity must be greater than 0",
      });

    if (!formValues.description || formValues.description === "<p><br></p>")
      return setMessage({
        status: true,
        reason: "error",
        desc: "Description is required",
      });

    try {
      const res = await fetch(`${API_URL}/api/assets/${assetData.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formValues),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage({
          status: true,
          reason: "success",
          desc: "Asset updated successfully!",
        });
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      setMessage({
        status: true,
        reason: "error",
        desc: `Failed to update asset: ${error.message}`,
      });
    }
  };

  return (
    <div className="card h-100 radius-12">
      <div className="card-body p-24">

        {message.status && (
          <div
            className={`alert alert-${
              message.reason === "error" ? "danger" : "success"
            } alert-dismissible fade show mb-20`}
          >
            {message.desc}
            <button
              type="button"
              className="btn-close"
              onClick={() => setMessage({ ...message, status: false })}
            ></button>
          </div>
        )}

        <form onSubmit={handleSubmit}>

          {/* Title */}
          <div className="mb-20">
            <label className="form-label fw-semibold">
              Asset Title <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control radius-8"
              value={formValues.title}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  title: e.target.value,
                }))
              }
            />
          </div>

          {/* Cost Price */}
          <div className="mb-20">
            <label className="form-label fw-semibold">
              Cost Price <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="form-control radius-8"
              min="0"
              value={formValues.costPrice}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  costPrice: e.target.value,
                }))
              }
            />
          </div>

          {/* Quantity */}
          <div className="mb-20">
            <label className="form-label fw-semibold">
              Quantity <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="form-control radius-8"
              min="1"
              value={formValues.quantity}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  quantity: e.target.value,
                }))
              }
            />
          </div>

          <div className="mb-20">
  <label className="form-label fw-semibold">Added On <span className="text-danger">*</span></label>
  <input
    type="date"
    className="form-control radius-8"
    value={formValues.addedOn}
    onChange={(e) =>
      setFormValues((prev) => ({ ...prev, addedOn: e.target.value }))
    }
  />
</div>


          {/* Description */}
          <div className="mb-20">
            <label className="form-label fw-semibold">
              Description <span className="text-danger">*</span>
            </label>
            <div ref={quillRef} className="ql-container" />
          </div>

          <div className="text-center">
            <button className="btn btn-primary px-56 py-12 radius-8">
              Update Asset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAssetLayer;
